// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__19I0h","colMaxWidth":"Table_colMaxWidth__iBfBd"};